module.exports = __webpack_public_path__ + "images/emoji/kissing_smiling_eyes.22c9875cd4fcf03dbfe6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/kissing_smiling_eyes.png
// module id = ON+V
// module chunks = 2